<template>
    <div>
        <div class="container-form" v-if="formLogin">            
            <div class="block-form block-form-login">
                <breadcrumbs-app title="Login" />
                <h2>Login</h2>
                <div class="error-message" v-if="errorLogin" v-html="errorLogin"></div>
                <v-form @submit.prevent v-model="valid" ref="form" validation @keyup.enter.prevent>
                    <p class="label">Email address or phone number</p>
                    <v-text-field name="login" type="text" v-model="login" :rules="loginRules" @focus="changeForm"
                    aria-describedby="input-3-messages" @keyup.enter="onSubmit"></v-text-field>
                    <p class="label">Password</p>
                    <v-text-field 
                    name="password" 
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    :counter="6" 
                    v-model="password" 
                    :rules="passwordRules"
                    autocomplete="current-password" 
                    aria-describedby="input-5-messages" 
                    @focus="changeForm" 
                    @keyup.enter="onSubmit"
                    @click:append="show1 = !show1"
                    class="el-password"
                    ></v-text-field>
                    <div class="form-bottom">  
                        <v-checkbox
                            v-model="remember"
                            label="Remember me"    
                            value="true"
                            hide-details
                            :class="{ 'active': remember }"
                        ></v-checkbox>
                        <p class="text-center"><span class="forgot-password" @click="viewFormForgot">Forgot Password?</span></p>                   
                    </div>
                    <div class="row-btn">
                        <v-btn type="submit" @click.prevent="onSubmit" :disabled="!valid">Login</v-btn>
                    </div>
                </v-form>             
            </div>
        </div>
        <div class="container-form fill-bg" v-if="formLogin">
            <div class="block-benefits">
                <h2>
                    Benefits of creating an account
                </h2>
                <ul>
                    <li>Lorem ipsum dolor</li>
                    <li>Lorem ipsum dolor</li>
                    <li>Lorem ipsum dolor sit amet consectetur</li>
                </ul>
                <div class="btn-create-account" @click.prevent="viewFormCreateAccount">Create an account now</div>
                <div class="row-bottom">
                    ...it only takes <strong> 1 minute</strong>
                </div>
            </div>
        </div>
        <div class="container-form" v-if="formCreateAccount">
            <div class="block-form block-form-ca">
                <breadcrumbs-app title="Create an account" />
                <h2>Join Clean Cut Meals</h2>
                <!-- <div class="block-top">
                    <div class="block-top-btn">
                        <span class="btn btn-facebook"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.75 8C15.75 3.71875 12.2812 0.25 8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 11.875 3.0625 15.0938 6.78125 15.6562V10.25H4.8125V8H6.78125V6.3125C6.78125 4.375 7.9375 3.28125 9.6875 3.28125C10.5625 3.28125 11.4375 3.4375 11.4375 3.4375V5.34375H10.4688C9.5 5.34375 9.1875 5.9375 9.1875 6.5625V8H11.3438L11 10.25H9.1875V15.6562C12.9062 15.0938 15.75 11.875 15.75 8Z" fill="white"/>
                            </svg>
                            Facebook
                        </span>
                        <span class="btn btn-google">
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.125 8.1875C16.125 7.6875 16.0625 7.3125 16 6.90625H8.625V9.5625H13C12.8438 10.7188 11.6875 12.9062 8.625 12.9062C5.96875 12.9062 3.8125 10.7188 3.8125 8C3.8125 3.65625 8.9375 1.65625 11.6875 4.3125L13.8125 2.28125C12.4688 1.03125 10.6875 0.25 8.625 0.25C4.3125 0.25 0.875 3.71875 0.875 8C0.875 12.3125 4.3125 15.75 8.625 15.75C13.0938 15.75 16.125 12.625 16.125 8.1875Z" fill="url(#paint0_angular_253_19712)"/>
                                <defs>
                                <radialGradient id="paint0_angular_253_19712" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 7) rotate(90) scale(10 8.88889)">
                                <stop offset="0.0913817" stop-color="#4285F4"/>
                                <stop offset="0.251265" stop-color="#EA4335"/>
                                <stop offset="0.632248" stop-color="#FBBC05"/>
                                <stop offset="0.764281" stop-color="#34A853"/>
                                </radialGradient>
                                </defs>
                            </svg>
                            Google</span>
                    </div>
                    <div class="block-separeted">or register with an email</div>
                </div> -->
                <div class="error-message" v-if="errorNewAccount" v-html="errorNewAccount"></div>
                <v-form @submit.prevent v-model="validCA" ref="form2" validation>
                    <v-row>
                        <p class="label"><sup>*</sup> Full Name</p>
                        <v-text-field name="firstName" type="text" v-model="name" :rules="nameRules" @focus="changeForm"></v-text-field>
                    </v-row>
                    <v-row>
                        <p class="label"><sup>*</sup> Email address</p>
                        <v-text-field name="email" type="email" v-model="email" :rules="emailRules" @focus="changeForm"
                        aria-describedby="input-3-messages"></v-text-field>
                    </v-row>
                    <v-row>
                        <p class="label"><sup>*</sup> Phone number</p>
                        <v-text-field name="phone" type="text" v-model="phone" :rules="phoneRules" @focus="changeForm"
                        aria-describedby="input-3-messages"></v-text-field>
                    </v-row>
                    <v-row>
                        <p class="label"><sup>*</sup> Password</p>
                        <v-text-field 
                        name="password" 
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show2 ? 'text' : 'password'"
                        :counter="6" 
                        v-model="password" 
                        :rules="passwordRules"
                        @focus="changeForm"
                        autocomplete="current-password" 
                        aria-describedby="input-5-messages"
                        @click:append="show2 = !show2"
                        class="el-password"
                        ></v-text-field>                
                    </v-row>
                    <v-row>               
                        <p class="label"><sup>*</sup> Repeat password</p>
                        <v-text-field
                        name="confirm-password"
                        :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show3 ? 'text' : 'password'"
                        :counter="6"
                        v-model="confirmPassword"
                        :rules="confirmPasswordRules"
                        @focus="changeForm"
                        @click:append="show3 = !show3"
                        class="el-password"
                        ></v-text-field>                    
                    </v-row>
                    <div class="form-bottom">  
                        <v-checkbox
                            v-model="police"
                            label="I agree to the"    
                            value="true"
                            hide-details
                            :rules="policeRules"
                            @focus="changeForm"
                        ></v-checkbox>  
                        <a href="/privacy-policy/">Privacy policy</a>                 
                    </div>
                    <div class="row-btn">                 
                    <v-btn type="submit" @click.prevent="onSubmitCA" :disabled="!validCA">Login</v-btn>
                    </div>
                </v-form>
                <div class="row-bottom">
                    <p class="back-login">Already have an account? <strong><span @click.prevent="viewFormLogin"> Login</span></strong></p>
                </div>               
            </div>
        </div>
        <div class="container-form" v-if="formForgot">
            <div class="block-form block-form-forgot">
                <breadcrumbs-app title="Forgot Password" />
                <h2>Forgot Password</h2>
                <div class="error-message" v-if="errorForgot" v-html="errorForgot"></div>
                <v-form @submit.prevent v-model="validForgot" ref="form3" validation v-if="!successForgot">
                    <p class="label">Email</p>
                    <v-text-field name="email" type="email" v-model="emailForgot" :rules="emailRules" @focus="hideError"
                        aria-describedby="input-3-messages"></v-text-field>
                    <div class="row-btn">                    
                        <v-btn type="submit" @click="sendForgot" :disabled="!validForgot">Send</v-btn>
                    </div>
                </v-form>
                <div v-else>
                  <div class="success-message" v-if="successForgot" v-html="successForgot"></div>
                </div>
                <div class="row-bottom">
                    <p class="back-login">Already have an account? <strong><span @click="viewFormLogin"> Login</span></strong></p>
                </div>
            </div>
        </div>
        <div class="container-form" v-if="formRestorePass">
            <div class="block-form block-form-forgot">
                <breadcrumbs-app title="Forgot Password" />
                <h2>Enter Password</h2>
                <div class="error-message" v-if="restorePassError" v-html="restorePassError"></div>
                <v-form @submit.prevent v-model="validRestorePass" ref="form4" validation>
                    <p class="label">Password</p>
                    <v-text-field name="pass1" type="password" v-model="pass1" :rules="pass1Rules" id="input-pass1" @focus="hideError"
                        aria-describedby="input-pass1-messages"></v-text-field>                
                    <p class="label">Confirm Password</p>
                        <v-text-field name="pass2" type="password" v-model="pass2" :rules="confirmRestorePasswordRules" id="input-pass2" @focus="hideError"
                        aria-describedby="input-pass2-messages"></v-text-field>
                        <div class="row-btn">                       
                        <v-btn type="submit" @click="sendRestorePass" :disabled="!validRestorePass">Restore</v-btn>
                    </div>
                </v-form>
                <div class="row-bottom">
                    <p class="back-login">Already have an account? <strong><span @click="viewFormLogin"> Login</span></strong></p>
                </div>
            </div>
        </div>
        <loaderApp v-if="loader"></loaderApp>
        <alertApp></alertApp>
    </div>
</template>

<script>

import { url, token } from '@/api/api.js'
import breadcrumbsApp from '@/components/basic/breadcrumbsApp.vue';
import loaderApp from '@/components/common/loaderApp.vue';
import alertApp from '@/components/common/alertApp.vue';

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/


export default {
    name: 'LoginApp',
    components: {
        breadcrumbsApp,
        loaderApp,
        alertApp
    },
    data() {
        return {
            remember: '',
            password: '',
            phone: '',
            show1: false,
            show2: false,
            show3: false,
            pass1: '',
            pass2: '',
            police: '',
            formForgot: false,
            formLogin: true,
            formRestorePass: false,
            formCreateAccount: false,
            valid: false,
            validCA: false,
            validForgot: false,
            validRestorePass: false,
            email: '',
            emailForgot: '',
            login: '',
            name: '',
            confirmPassword: '',
            emailRules: [
                v => !!v || 'Email is required',
                v => emailRegex.test(v) || 'E-mail must be valid'
            ],  
            policeRules: [
                v => !!v || 'Field is required',
            ],         
            loginRules: [
                v => !!v || 'Field is required',
            ],
            nameRules: [
                v => !!v || 'Name is required',
            ],
            phoneRules: [
                v => !!v || 'Phone is required',
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v => (v && v.length >= 6) || 'Password must be equal or more than 6 characters'
            ],
            confirmPasswordRules: [
                v => !!v || 'Password is required',
                v => v === this.password || 'Password should match'
            ],
            pass1Rules: [
                v => !!v || 'Password is required',
                v => (v && v.length >= 6) || 'Password must be equal or more than 6 characters'
            ],
             confirmRestorePasswordRules: [
                v => !!v || 'Password is required',
                v => v === this.pass1 || 'Password should match'
            ],
        }
    },
    computed: {
        loader() {
            return this.$store.getters.loader ?? false;
        },
        errorForgot() {
            return this.$store.getters.errorForgot;
        },
        successForgot() {
            return this.$store.getters.successForgot;
        },
        restorePassError() {
            return this.$store.getters.restorePassError;
        },
        errorLogin() {
            return this.$store.getters.errorLogin;
        },
        errorNewAccount() {
            return this.$store.getters.errorNewAccount;
        },
    },
    methods: {
        hideError() {
            if (this.errorForgot) {
                this.$store.commit('setErrorForgot', '');
            }

            if (this.restorePassError) {
                this.$store.commit('setRestorePassError', '');
            }
        },
        sendForgot() {

            if (this.$refs.form3.validate()) {             
                this.$store.dispatch('sendForgot', { email: this.emailForgot });
            }
        },
        sendRestorePass() {

            if(this.login && this.pass1) {
                this.$store.dispatch('restorePassword', { email: this.login, password: this.pass1 })
            } else {
                this.$store.commit('setErrorForgot', 'Error: Please try again');
            }
        },
        changeForm() {
            this.$store.commit('setUserLogin', '');
            this.$store.commit('setErrorNewAccount', '');
        },
        onSubmit() {
            if (this.$refs.form.validate()) {
                const user = {
                    login: this.login,
                    password: this.password,
                    remember: this.remember
                }
              
                this.$store.dispatch('sendUserData', user);
            }
        },
        onSubmitCA() {
            if (this.$refs.form2.validate()) {
                this.validCA = false;
                const friendscode = window.location.search.split('?friend=');
                const user = {
                    name: this.name,
                    phone: this.phone,
                    email: this.email,
                    password: this.password,
                    friendscode: friendscode[1]
                }

                this.$store.dispatch('createUserAccount', user);
            }
        },
        viewFormCreateAccount() {
            this.formLogin = false;
            this.formRestorePass = false;
            this.formCreateAccount = true;
        },
        viewFormForgot() {
            
            this.formLogin = false;
            this.emailForgot = '';
            this.formForgot = true;
            this.formRestorePass = false;
            this.$store.commit('setSuccessForgot', '');
        
        },
        viewFormLogin() {
            this.formForgot = false;
            this.formRestorePass = false;
            this.formCreateAccount = false;
            this.formLogin = true;
            window.scrollTo(0, 0);
        }
    },
    async beforeMount() {

        let myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append('Content-Type', 'application/json');

        let requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: myHeaders,
            redirect: 'follow'
        };

        const currentUrl = window.location.search.split('&');

        if (currentUrl[0] == '?action=rp') {
            let key = currentUrl[1].split('=');
            let login = currentUrl[2].split('=');
            if (key[1].length > 0 && login[1].length) { 

                this.login = login[1].replace('%40', '@');
                requestOptions.body = JSON.stringify({ "login": this.login, key: key[1] });
                
                try {
                    const Data = await fetch(url + "/wp-json/ccm-settings/v1/get-restore-pass", requestOptions);

                    const data = await Data.text();
                    const res = await JSON.parse(data);

                    if (res && res.error) {
                        this.$store.commit('setErrorForgot', res.error + ' Please try again');

                        this.formLogin = false;
                        this.formForgot = true;

                    } else {
                        this.formLogin = false;
                        this.formRestorePass = true;
                    }

                } catch (error) {

                    console.log('error', error.message);
                    throw error;

                }

            }
        }

        if (currentUrl[0] == '?action=fl') {
            let form = currentUrl[1].split('=');

            if (form[1] == 'login') {
                this.formForgot = false;
                this.formRestorePass = false;
                this.formLogin = true;
            }
        }

    },
}
</script >

<style lang="stylus">
* {
  box-sizing: border-box;
}
.v-field__outline,
.v-btn__overlay,
.v-field__overlay,
.v-btn__underlay {
  display: none!important;
}

.container-form {

    &.fill-bg {
        background: #F8F9FC;
        padding: .5rem 0;
    }

    .block-benefits {
        color: #1D2433;
        max-width: 630px;
        margin: auto;
        padding: 2rem 15px;
        flex-direction: column;

        ul {
            padding: 1rem 0 2rem;
            margin: 0;
            list-style: none;

            li {
                position: relative;
                padding: .5rem 0 .5rem 3rem;
                font-family: 'Manrope', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                color: #1D2433;

                &:after {
                    position: absolute;
                    content: '';
                    top: 5px;
                    width:30px;
                    height: 30px;
                    background: #685BC7;
                    left: 0;
                    background: url(/src/assets/images/icons/tick.svg) no-repeat center / 22px 32px;
                }
            }
        }

        .btn-create-account {
            border-radius: 10px;
            background: #2AD2C9;
            color: #1D2433;
            width: 100%;
            transition-duration: .4s;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            font-family: 'Manrope', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: none;
            cursor: pointer;

            &.v-btn--disabled {
                opacity: .6;
            }

            &:hover {
                background: #685BC7;
                color: #fff;
            }
        }

        .row-bottom {
            padding: 2rem 0 .5rem;
            display: flex;
            align-items: center;
            justify-content: center;

            strong {
                padding-left: 5px;
            }
        }
    }

    .block-form-forgot,
    .block-form-ca {

        .block-top {
            margin: 1.5rem 0;
            
            .block-separeted {
                text-align: center;
                position: relative;
                
                &:before {
                    position: absolute;
                    content: '';
                    top: 50%;
                    width: calc(50% - 120px);
                    height: 2px;
                    background: #ccc;
                    left: 0;
                }

                &:after {
                    position: absolute;
                    content: '';
                    top: 50%;
                    width: calc(50% - 120px);
                    height: 2px;
                    background: #E1E6EF;
                    right: 0;
                }
            }

            .block-top-btn {
                margin-bottom: 1.5rem;
                display: flex;
                align-item: center;
                justify-content: space-between;

                .btn {
                    border-radius: 10px;       
                    width: 161px;
                    height: 50px;
                    padding: 10px 16px;
                    justify-content: center;
                    align-items: center;
                    font-family: 'Manrope', sans-serif;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    cursor: pointer;
                    display: flex;
                    transition-duration: .4s;

                    & > svg {
                        margin-right: 10px;
                    }

                    &-facebook {
                        background: #1877F2;
                        color: #fff;
                        
                        &:hover {
                            background: rgba(45, 104, 179, 1);
                        }
                    }

                    &-google {
                        border: 2px solid #1D2433;

                        &:hover {
                            background: rgba(0, 0, 0, .1);
                        }
                    }
                }
            }
        }
        .v-row {
            display: flex;
            flex-direction: column;
            max-width: 100%;
            margin: 0;
        }

        .row-bottom {
            display: flex;
            justify-content: center;
            color: #201747;
            font-family: 'Manrope', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }

        .form-bottom {
            justify-content: flex-start!important;            

            .v-checkbox {
                max-width: 150px;
            }

            .v-input__control {
                display: inline-flex;
            }

            label {
                color: #201747;
                font-family: 'Manrope', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                opacity: 1;
                letter-spacing: normal;
            }

            .back-login span,
            a {
                color: #685BC7;
                text-align: center;
                font-family: 'Manrope', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                text-decoration: none;
                transition-duration: .4s;
                position: relative;

                &:after {
                    position: absolute;
                    content: '';
                    bottom: -2px;
                    width: 100%;
                    height: 2px;
                    background-color: #685BC7;
                    transition-duration: .4s;
                    left: 0;
                }

                &:hover:after {
                    width: 0;                
                }
            }
        }
    }

    .block-form {
        color: #1D2433;
        max-width: 630px;
        margin: auto;
        padding: 2rem 15px;

        sup {
            color: red;
        }

        h2 {
            margin-bottom: 1rem;
            color: #1D2433;
            font-family: 'Manrope', sans-serif;
            font-size: 26px;
            font-style: normal;
            font-weight: 800;
            line-height: normal;
        }

        .label {
            font-family: Manrope;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            padding-bottom: 0.5rem;
        }

        input[type=text],
        input[type=email],
        input[type=password] {
            border-radius: 10px;
            background: #fff!important;
            border: 2px solid #E1E6EF;
        }

        .form-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;

            label {
                color: #201747;
                font-family: 'Manrope', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }

            .mdi-checkbox-blank-outline {
                opacity: 1;
                background: url(/src/assets/images/icons/not-checked.svg) no-repeat center / 22px 32px;
            }

            .mdi-checkbox-marked {
                background: url(/src/assets/images/icons/check.svg) no-repeat center / 22px 32px;
            }
        }

        .forgot-password {
            cursor: pointer;
            font-family: 'Manrope', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            color: #685BC7;
            transition-duration: .4s;
            position: relative;

            &:after {
                position: absolute;
                content: '';
                bottom: -5px;
                width: 100%;
                height: 2px;
                background-color: #685BC7;
                transition-duration: .4s;
                left: 0;
            }

            &:hover:after {
                width: 0;                
            }
        }

        .el-password {
            position: relative;
        }

        .row-btn {
            margin: 2rem 0;
            cursor: pointer;

            button {
                border-radius: 10px;
                background: #685BC7;
                color: #fff;
                width: 100%;
                transition-duration: .4s;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                font-family: 'Manrope', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                text-transform: none;
                cursor: pointer;

                &.v-btn--disabled {
                    opacity: .6;
                }

                &:hover {
                    background: #50469a;
                }
            }
            &:hover button {
                background: #50469a;
            }
        }

        .v-input__append {
            position: absolute!important;
            top: 3px!important;
            right: 10px!important;
            z-index: 999;
            width: 30px;
            opacity: 1;

            i.mdi-eye {
                opacity: 1;
                background: url(/src/assets/images/icons/eye.svg) no-repeat center / 22px 32px;
            }

            i.mdi-eye-off {
                opacity: 1;
                background: url(/src/assets/images/icons/eye-no.svg) no-repeat center / 22px 32px;
            }

        }
    }

    .back-login span {
        color: #685BC7;
        text-align: center;
        font-family: 'Manrope', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-decoration: none;
        transition-duration: .4s;
        position: relative;
        cursor: pointer;

        &:after {
            position: absolute;
            content: '';
            bottom: -2px;
            width: 100%;
            height: 2px;
            background-color: #685BC7;
            transition-duration: .4s;
            left: 0;
        }

        &:hover:after {
            width: 0;                
        }
    }

    .v-input__details {
        min-height: 10px;
        padding-top: 3px;
        padding-bottom: 3px;
    }
}
</style>
